/* Lympharis theme JS */
(function () {
  'use strict';

  /* ---------- Countdown timer ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var minutes = parseInt(el.dataset.countdownMinutes || '240', 10);
    var key = 'lympharis_countdown_end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      sessionStorage.setItem(key, String(end));
    }
    var h = el.querySelector('[data-hrs]'), m = el.querySelector('[data-mins]'), s = el.querySelector('[data-secs]');
    function tick() {
      var d = Math.max(0, end - Date.now());
      var hh = Math.floor(d / 3600000), mm = Math.floor(d / 60000) % 60, ss = Math.floor(d / 1000) % 60;
      if (h) h.textContent = String(hh).padStart(2, '0');
      if (m) m.textContent = String(mm).padStart(2, '0');
      if (s) s.textContent = String(ss).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Drawers (nav + cart) ---------- */
  function bindDrawer(openSel, drawerSel) {
    var drawer = document.querySelector(drawerSel);
    if (!drawer) return;
    document.querySelectorAll(openSel).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }
  bindDrawer('[data-nav-open]', '#NavDrawer');
  bindDrawer('[data-cart-open]', '#CartDrawer');

  function openCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  /* ---------- Cart AJAX ---------- */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function refreshCartDrawer() {
    fetch(root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer .cart-drawer__panel');
        var current = document.querySelector('#CartDrawer .cart-drawer__panel');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          if (count) el.textContent = count.textContent;
        });
        bindCartLines();
        var drawer = document.getElementById('CartDrawer');
        if (drawer) {
          drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              drawer.classList.remove('is-open');
              document.body.style.overflow = '';
            });
          });
        }
      });
  }

  function bindCartLines() {
    document.querySelectorAll('[data-line-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.dataset.line;
        var qty = parseInt(btn.dataset.qty, 10);
        fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
        }).then(refreshCartDrawer);
      });
    });
  }
  bindCartLines();

  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding\u2026'; }
      fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { refreshCartDrawer(); openCartDrawer(); })
        .catch(function () { window.location.href = root + 'cart'; })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        });
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) { main.src = thumb.dataset.src; main.srcset = ''; }
      });
    });
  });

  /* ---------- Bundle selector ---------- */
  document.querySelectorAll('[data-bundle-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    picker.querySelectorAll('.bundle').forEach(function (option) {
      option.addEventListener('click', function () {
        picker.querySelectorAll('.bundle').forEach(function (o) { o.classList.remove('is-selected'); });
        option.classList.add('is-selected');
        var input = option.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        if (form) {
          var idField = form.querySelector('input[name="id"]');
          var qtyField = form.querySelector('input[name="quantity"]');
          if (idField && option.dataset.variantId) idField.value = option.dataset.variantId;
          if (qtyField && option.dataset.quantity) qtyField.value = option.dataset.quantity;
          var priceEl = form.querySelector('[data-atc-price]');
          if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
          var compareEl = form.querySelector('[data-atc-compare]');
          if (compareEl) compareEl.textContent = option.dataset.compare || '';
          form.dispatchEvent(new CustomEvent('variant:change'));
        }
      });
    });
  });

  /* ---------- Purchase-type toggle (selling plans) ---------- */
  document.querySelectorAll('[data-buy-toggle]').forEach(function (toggle) {
    var form = toggle.closest('form');
    var planInput = form && form.querySelector('[data-selling-plan-input]');
    var planSelectWrap = form && form.querySelector('[data-plan-select]');
    var planSelect = planSelectWrap && planSelectWrap.querySelector('select');
    var subBtn = toggle.querySelector('[data-buy-subscribe]');
    var priceEl = form && form.querySelector('[data-atc-price]');
    var basePrice = priceEl ? priceEl.textContent : '';
    var planData = null;
    var dataEl = form && form.querySelector('[data-selling-plan-data]');
    if (dataEl) {
      try { planData = JSON.parse(dataEl.textContent); } catch (err) { planData = null; }
    }

    function currentPlanId() {
      if (planSelect && planSelect.value) return planSelect.value;
      return subBtn ? subBtn.dataset.defaultPlan || '' : '';
    }

    function isSubscribing() {
      return !!(subBtn && subBtn.classList.contains('is-selected'));
    }

    function oneTimePrice() {
      var selected = form && form.querySelector('.bundle.is-selected');
      if (selected && selected.dataset.price) return selected.dataset.price;
      return basePrice;
    }

    function updateState() {
      if (!form) return;
      var subscribing = isSubscribing();
      var planId = currentPlanId();
      if (planInput) {
        planInput.value = subscribing ? planId : '';
        planInput.disabled = !subscribing || !planId;
      }
      if (planSelectWrap) planSelectWrap.hidden = !subscribing;
      if (priceEl) {
        var compareEl = form.querySelector('[data-atc-compare]');
        var applied = false;
        if (subscribing && planData) {
          var idField = form.querySelector('input[name="id"]');
          var variantPlans = idField && planData[idField.value];
          var alloc = variantPlans && variantPlans[planId];
          if (alloc && alloc.price) {
            priceEl.textContent = alloc.price;
            if (compareEl) compareEl.textContent = alloc.compare && alloc.compare !== alloc.price ? alloc.compare : '';
            applied = true;
          }
        }
        if (!applied) {
          priceEl.textContent = oneTimePrice();
          if (compareEl) {
            var selected = form.querySelector('.bundle.is-selected');
            compareEl.textContent = selected ? (selected.dataset.compare || '') : '';
          }
        }
      }
    }

    toggle.querySelectorAll('.buy-toggle__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggle.querySelectorAll('.buy-toggle__opt').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateState();
      });
    });
    if (planSelect) planSelect.addEventListener('change', updateState);
    if (form) form.addEventListener('variant:change', updateState);
  });

  /* ---------- Sticky CTA ---------- */
  var sticky = document.querySelector('[data-sticky-cta]');
  var anchor = document.querySelector('#offerscroll');
  if (sticky && anchor) {
    window.addEventListener('scroll', function () {
      var past = window.scrollY > 600;
      var beforeOffer = anchor.getBoundingClientRect().top > window.innerHeight;
      sticky.classList.toggle('is-visible', past && beforeOffer);
    }, { passive: true });
  }
})();

// Benefits with image: highlight clicked item
document.querySelectorAll('[data-benefits-media]').forEach(function(list){
  list.querySelectorAll('[data-benefit-item]').forEach(function(item){
    item.addEventListener('click', function(){
      list.querySelectorAll('[data-benefit-item]').forEach(function(i){ i.classList.remove('is-active'); });
      item.classList.add('is-active');
    });
  });
});

// Ritual steps carousel nav (mobile)
document.querySelectorAll('.ritual-nav-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var grid = document.getElementById(btn.dataset.target);
    if (!grid) return;
    var card = grid.querySelector('.ritual-step');
    if (!card) return;
    var w = card.offsetWidth + 14; // width + gap
    grid.scrollBy({ left: parseInt(btn.dataset.dir) * w, behavior: 'smooth' });
  });
});

// Results carousel – track scroll by index
function initResultsCarousel(trackId) {
  var track = document.getElementById(trackId);
  if (!track) return;
  var cards = track.querySelectorAll('.rcard');
  var dots = document.querySelectorAll('[data-dots-track="' + trackId + '"]');
  var current = 0;
  function goTo(idx) {
    idx = Math.max(0, Math.min(idx, cards.length - 1));
    current = idx;
    var perView = window.innerWidth > 820 ? 3 : 1;
    var gap = 20;
    var cardW = cards[0] ? cards[0].offsetWidth + gap : 0;
    track.style.transform = 'translateX(-' + (current * cardW) + 'px)';
    dots.forEach(function(d, i){ d.classList.toggle('is-active', i === current); });
  }
  dots.forEach(function(dot) {
    dot.addEventListener('click', function(){ goTo(parseInt(dot.dataset.index)); });
  });
  // hook into existing nav buttons
  document.querySelectorAll('.ritual-nav-btn[data-target="' + trackId + '"]').forEach(function(btn){
    btn.addEventListener('click', function(){ goTo(current + parseInt(btn.dataset.dir)); });
  });
}
document.querySelectorAll('.results-carousel__track').forEach(function(t){ initResultsCarousel(t.id); });
